import { safeArtwork } from './no1001';

// The pictures an entity can show, in order: the primary url (what the row /
// page already carries) first, then the catalogue's full `covers` list
// [{ url, source }] as the server returns it (best source first, Apple at
// rank 1). 1001-hosted urls never pass (safeArtwork), duplicates collapse.
export function coverChain(primary, covers) {
    const out = [];
    const push = (u) => { const s = safeArtwork(u); if (s && !out.includes(s)) out.push(s); };
    push(primary);
    if (Array.isArray(covers)) for (const c of covers) push(typeof c === 'string' ? c : c?.url);
    return out;
}

// The second picture of an entity, for a banner / cover behind the hero: the
// first cover that is a genuinely different photo from the first one. Two
// pictures are different when both carry the catalogue's perceptual hash
// (`phash`, a 64-bit dHash sent as a string) and they differ in more than
// PHASH_SAME bits; when either hash is missing, a different source has to do
// (Apple vs SoundCloud). Same-photo covers are skipped, the walk moves on.
export const PHASH_SAME = 6;
/* global BigInt */
export function phashDistance(a, b) {
    let x = BigInt.asUintN(64, BigInt(a)) ^ BigInt.asUintN(64, BigInt(b));
    let n = 0;
    while (x) { n += Number(x & 1n); x >>= 1n; }
    return n;
}
const hasPhash = (c) => c?.phash !== undefined && c?.phash !== null && c?.phash !== '';
function differentPhoto(a, b) {
    if (hasPhash(a) && hasPhash(b)) return phashDistance(a.phash, b.phash) > PHASH_SAME;
    return (a.source || '') !== (b.source || '');
}
export function secondCover(covers) {
    if (!Array.isArray(covers) || covers.length < 2) return null;
    const first = covers.find((c) => safeArtwork(c?.url));
    if (!first) return null;
    const alt = covers.find((c) => safeArtwork(c?.url) && c.url !== first.url && differentPhoto(first, c));
    return alt ? alt.url : null;
}
